import {
    CREATE_CALENDAR_QUESTION,
    CREATE_CALENDAR_QUESTION_SUCCESS,
    DELETE_CALENDAR_QUESTION,
    DELETE_CALENDAR_QUESTION_SUCCESS,
    GET_CALENDAR_QUIZZES_LIST,
    GET_CALENDAR_QUIZZES_LIST_SUCCESS,
    CALENDAR_QUESTION_COPY,
    CALENDAR_QUESTION_COPY_SUCCESS,
    UPLOAD_CALENDAR_QUESTION_COVER,
    UPLOAD_CALENDAR_QUESTION_COVER_SUCCESS,
    UPDATE_CALENDAR_QUESTION,
    UPDATE_CALENDAR_QUESTION_SUCCESS,
    GET_HATCH_QUESTIONS,
    GET_HATCH_QUESTIONS_SUCCESS,
    CALENDAR_QUESTION_PIN,
    CALENDAR_QUESTION_PIN_SUCCESS,
    UPDATE_CALENDAR_QUESTION_COVER,
    UPDATE_CALENDAR_QUESTION_COVER_SUCCESS,
    UPDATE_CALENDAR_QUESTION_DRAG_DROP,
    UPDATE_CALENDAR_QUESTION_DRAG_DROP_SUCCESS,
} from './constants';

/**
 *
 * @param hatchID
 * @param questionType
 * @param questionText
 * @param langID
 * @returns {{hatchID: *, type: string, langID: *, questionType: *, questionText: *}}
 */
const createCalendarQuestion = ( hatchID, questionType, questionText, langID ) => ( {
    type: CREATE_CALENDAR_QUESTION,
    hatchID,
    questionType,
    questionText,
    langID
} );
/**
 *
 * @param question
 * @returns {{question: *, type: string}}
 */
const createCalendarQuestionSuccess = question => ( {
    type: CREATE_CALENDAR_QUESTION_SUCCESS,
    question
} );
/**
 *
 * @param hatchID
 * @returns {{hatchID: *, type: string}}
 */
const getHatchQuestions = hatchID => ( {
    type: GET_HATCH_QUESTIONS,
    hatchID
} );
/**
 *
 * @param questions
 * @returns {{questions: *, type: string}}
 */
const getHatchQuestionsSuccess = questions => ( {
    type: GET_HATCH_QUESTIONS_SUCCESS,
    questions
} );
/**
 *
 * @param questionID
 * @returns {{questionID: *, type: string}}
 */
const deleteCalendarQuestion = questionID => ( {
    type: DELETE_CALENDAR_QUESTION,
    questionID
} );
/**
 *
 * @param question
 * @returns {{question: *, type: string}}
 */
const deleteCalendarQuestionSuccess = question => ( {
    type: DELETE_CALENDAR_QUESTION_SUCCESS,
    question
} );
/**
 *
 * @returns {{type: string}}
 */
const getCalendarQuizzesList = () => ( {
    type: GET_CALENDAR_QUIZZES_LIST
} );
/**
 *
 * @param quizzesList
 * @returns {{type: string, quizzesList: *}}
 */
const getCalendarQuizzesListSuccess = quizzesList => ( {
    type: GET_CALENDAR_QUIZZES_LIST_SUCCESS,
    quizzesList
} );
/**
 *
 * @param questionID
 * @param hatchID
 * @returns {{questionID: *, hatchID: *, type: string}}
 */
const calendarQuestionCopy = ( questionID, hatchID ) => ( {
    type: CALENDAR_QUESTION_COPY,
    questionID,
    hatchID
} );
/**
 *
 * @param question
 * @returns {{question: *, type: string}}
 */
const calendarQuestionCopySuccess = question => ( {
    type: CALENDAR_QUESTION_COPY_SUCCESS,
    question
} );
/**
 *
 * @param questionID
 * @param localizationID
 * @param image
 * @param screenType
 * @returns {{image: *, questionID: *, localizationID: *, screenType: *, type: string}}
 */
const uploadCalendarQuestionCover = ( questionID, localizationID, image, screenType ) => ( {
    type: UPLOAD_CALENDAR_QUESTION_COVER,
    localizationID,
    questionID,
    image,
    screenType
} );
/**
 *
 * @param question
 * @returns {{question: *, type: string}}
 */
const uploadCalendarQuestionCoverSuccess = ( question ) => ( {
    type: UPLOAD_CALENDAR_QUESTION_COVER_SUCCESS,
    question
} );
/**
 *
 * @param questionID
 * @param keyName
 * @param updateQuestionPiece
 * @returns {{questionID: *, updateQuestionPiece: *, keyName: *, type: string}}
 */
const updateCalendarQuestion = ( questionID, keyName, updateQuestionPiece ) => ( {
    type: UPDATE_CALENDAR_QUESTION,
    questionID,
    keyName,
    updateQuestionPiece
} );
/**
 *
 * @param updatedQuestionPiece
 * @returns {{updatedQuestionPiece: *, type: string}}
 */
const updateCalendarQuestionSuccess = ( updatedQuestionPiece ) => ( {
    type: UPDATE_CALENDAR_QUESTION_SUCCESS,
    updatedQuestionPiece
} );
/**
 *
 * @param localizationID
 * @returns {{localizationID: *, type: string}}
 */
const hatchQuestionPin = localizationID => ( {
    type: CALENDAR_QUESTION_PIN,
    localizationID
} );
/**
 *
 * @param question
 * @returns {{question: *, type: string}}
 */
const hatchQuestionPinSuccess = question => ( {
    type: CALENDAR_QUESTION_PIN_SUCCESS,
    question
} );
/**
 *
 * @param id
 * @param localizationId
 * @returns {{localizationId: *, id: *, type: string}}
 */
const updateCalendarQuestionCover = ( id, localizationId ) => ( {
    type: UPDATE_CALENDAR_QUESTION_COVER,
    id,
    localizationId
} );
/**
 *
 * @param question
 * @returns {{question: *, type: string}}
 */
const updateCalendarQuestionCoverSuccess = question => ( {
    type: UPDATE_CALENDAR_QUESTION_COVER_SUCCESS,
    question
} );
const updateQuestionDragDrop = (id, result) => ({
    type: UPDATE_CALENDAR_QUESTION_DRAG_DROP,
    id,
    result
});
/**
 *
 * @param newQuestions
 * @returns {{newQuestions: *, type: string}}
 */
const updateQuestionDragDropSuccess = (newQuestions) => ({
    type: UPDATE_CALENDAR_QUESTION_DRAG_DROP_SUCCESS,
    newQuestions
});
export {
    updateQuestionDragDrop,
    updateQuestionDragDropSuccess,
    createCalendarQuestion,
    createCalendarQuestionSuccess,
    deleteCalendarQuestion,
    deleteCalendarQuestionSuccess,
    getCalendarQuizzesList,
    getCalendarQuizzesListSuccess,
    calendarQuestionCopy,
    calendarQuestionCopySuccess,
    uploadCalendarQuestionCover,
    uploadCalendarQuestionCoverSuccess,
    updateCalendarQuestion,
    updateCalendarQuestionSuccess,
    getHatchQuestions,
    getHatchQuestionsSuccess,
    hatchQuestionPin,
    hatchQuestionPinSuccess,
    updateCalendarQuestionCover,
    updateCalendarQuestionCoverSuccess
};